import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import api from "../../../utils/api";
import "./AdminLogin.scss";

const AdminLogin = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const history = useHistory();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      const response = await api.login(username, password);
      
      if (response.user) {
        const userData = {
          ID: response.user.id,
          AUTHTOKEN: response.authToken,
          REFRESH_TOKEN: response.refreshToken || response.authToken,
          ...response.user,
        };
        localStorage.setItem("BEGROSS_USER", JSON.stringify(userData));
        history.push("/admin");
      } else {
        setError("Invalid response from server");
        setLoading(false);
      }
    } catch (err) {
      console.error("Login error:", err);
      setError(err.message || "Login failed");
      setLoading(false);
    }
  };

  return (
    <div className="admin-login">
      <div className="admin-login-container">
        <div className="admin-login-box">
          <h1>Begmart Admin</h1>
          <p>Sign in to access the admin panel</p>

          <form onSubmit={handleSubmit}>
            {error && <div className="error-message">{error}</div>}

            <div className="form-group">
              <label>Username or Email</label>
              <input
                type="text"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                required
                placeholder="Enter your username or email"
              />
            </div>

            <div className="form-group">
              <label>Password</label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                placeholder="Enter your password"
              />
            </div>

            <button type="submit" disabled={loading} className="login-btn">
              {loading ? "Signing in..." : "Sign In"}
            </button>
          </form>

          <div className="admin-login-footer">
            <p>Use your admin account credentials</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;


